import getConfig from 'next/config'

import { createMutationHook } from '@fe-toolkit/react-query-hooks-toolkit'

import { createCommonApiClient } from '@giffgaff/broadband-common'

import createApiWithConfig from '@/api'

const { publicRuntimeConfig } = getConfig()

const apiClient = createApiWithConfig(publicRuntimeConfig, {
  onResponseValidationError: ({ validateResponseGlobal, validateResponseLocal }) => {
    if (validateResponseLocal ?? validateResponseGlobal) {
      // TODO: reinstate this once we are not getting zod schema errors.
      // setErrorCode(500)
    }
  },
})

const { api: publicApi, uploadEvidenceSessionEvidence } = apiClient.publicApi

export const useUpdateOrderActiveAppointment = createMutationHook(publicApi.updateOrderActiveAppointments)
export const useConfirmChangePlan = createMutationHook(publicApi.confirmChangePlan)
export const useCreateDraftPlan = createMutationHook(publicApi.createDraftPlan)
export const useCreatePlanBuyoutClaim = createMutationHook(publicApi.createPlanBuyoutClaim)
export const useUploadEvidenceSessionEvidence = createMutationHook(uploadEvidenceSessionEvidence)
export const useDeleteEvidenceSessionEvidence = createMutationHook(publicApi.deleteEvidenceSessionEvidence)
export const useUpdateEvidenceSession = createMutationHook(publicApi.updateEvidenceSession)
export const useConfirmEvidenceSession = createMutationHook(publicApi.confirmEvidenceSession)

const submitEvidenceSessionClaim = async (params: Parameters<typeof publicApi.updateEvidenceSession>[0]) => {
  await publicApi.updateEvidenceSession(params)

  return publicApi.confirmEvidenceSession({ evidenceSessionId: params.evidenceSessionId })
}

export const useSubmitEvidenceSessionClaim = createMutationHook(submitEvidenceSessionClaim)

export const {
  useGetIntercomMember,
  useGetAvailableAppointments,
  useUpdateAppointment,
  useUpdateEngineerNotes,
  useGenerateContract,
  useGetBanners,
  useDeleteBanner,
  useFetchMoreAvailableAppointments,
  useCreateAppointmentReservation,
  useGetInstallationAppointments,
  useGetSwitchById,
} = createCommonApiClient({
  baseURL: publicRuntimeConfig.PUBLIC_API_URL,
})
